import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "profile", // slice name
  initialState: {
    value: null,
  },
  reducers: {
    setProfileData: (state, action) => {
      state.value = action.payload;
    },
    resetProfileData: (state) => {
      state.value = null;
    },
  },
});

export const { setProfileData, resetProfileData } = profileSlice.actions;
export default profileSlice.reducer; // export component
